type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'Route'
const nameSource = 'partnerships/routes'
const namePageTitle = 'Agencies'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Agencies',
  to: '/partnerships/routes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/partnerships/routes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/partnerships/routes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/partnerships/routes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export enum ROUTE_PRIORITY_ENUM {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum ROUTE_STATUS_ENUM {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed'
}

export const ROUTE_PRIORITY_MAP: Record<ROUTE_PRIORITY_ENUM, string> = {
  low: 'baixa',
  medium: 'média',
  high: 'alta'
}

export const ROUTE_STATUS_MAP: Record<ROUTE_STATUS_ENUM, string> = {
  pending: 'pendente',
  in_progress: 'em progresso',
  cancelled: 'cancelada',
  completed: 'finalizada'
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
